import {
  checkNodeCondition,
  checkNodeParentCondition,
  checkSelectedNodesCondition,
} from "./nodeCondition";
import { normalizeSuggestionKeywords } from "./normalizeKeywords";

import type { SingleSuggestion } from "@/components/suggestions/types";
import type { Operator, OperatorTypeValue, OperatorVariant, LocaleKeywords } from "@corca/data";
import type { LatexJson } from "@corca/data/latex-exports";

export { checkNodeCondition, checkSelectedNodesCondition, checkNodeParentCondition };

export function mapOperatorPropertiesToSuggestion(
  operator: Operator,
  operatorType: OperatorTypeValue,
  latexExportsJson: LatexJson,
  variant?: OperatorVariant,
  allKeywords?: LocaleKeywords,
): SingleSuggestion<"operator"> | null {
  const mergedKeywords = normalizeSuggestionKeywords(
    operator,
    variant,
    operator.key ? { keywords: latexExportsJson[operator.key]?.imports } : undefined,
  );

  if (Object.keys(mergedKeywords).length === 0) return null;

  // TODO: refactor
  return {
    type: "single",
    item: {
      type: "operator",
      ...operator,
      ...variant,
      props: {
        operatorType,
      },
      value: undefined,
      variantKeywords: mergedKeywords,
      keywords: allKeywords ?? mergedKeywords,
    },
    substitution: variant?.substitution ?? operator.substitution,
    priority: variant?.priority ?? operator.priority ?? 1,
    priorityRules: variant?.priorityRules ?? operator.priorityRules,
    filterRules: variant?.filterRules ?? operator.filterRules,
    icon: variant?.icon ?? operator?.icon,
    canAutocomplete: variant?.canAutocomplete ?? operator.canAutocomplete,
    popupGroup: variant?.popupGroup ?? operator.popupGroup,
    nestedKey: variant?.nestedKey ?? operator.nestedKey,
    nestedOnly: variant?.nestedOnly ?? operator.nestedOnly,
    action: variant?.action ?? operator.action,
  };
}
